

class PricePointController {
	/*@ngInject*/
	constructor(Auth, $state, User, PricePointService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.PricePointService = PricePointService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$scope = $scope;
		this.$translate = $translate;
		this.branchId = this.User.getUser().branchId;
		this.hasACL = {};
		this.pricePoints = [];
		this.total = 0
		this.moment = moment;
		this.errorMessage = '';
		this.sortColumn = "date";
		this.reverseSort = true;

		this.rawId = null;
		this.page = 1;
		this.filter = {
			sortingKey: this.sortColumn,
			sortingDir: this.reverseSort,
			limit: 10,
			page: this.page
		}

		this.minVaultDate = {
			minDate: moment().startOf('day').format('YYYY-MM-DD hh:mm a')
		}


		this.periodList = [
			{
				label: this.$translate.instant('fuel_surcharge.applied_monthly'),
				value: 'MONTHLY'
			},
			// {
			// 	label: this.$translate.instant('fuel_surcharge.applied_bi_weekly'),
			// 	value: 'BI_WEEKLY'
			// },
			// {
			// 	label: this.$translate.instant('fuel_surcharge.applied_weekly'),
			// 	value: 'WEEKLY'
			// },
		];

		this.defaultModel = {
			branchId: this.branchId,
			date: '',
			pricePoint: '',
			period: 'MONTHLY',
			periodApplied: '',
			comment: '',
		}

		this.model = angular.copy(this.defaultModel)
	}

	$onInit() {
		let fuelSurchargesACL = this.User.getACL("price_point");
		if (fuelSurchargesACL && fuelSurchargesACL.length) {
			fuelSurchargesACL.forEach(key => {
				this.hasACL[key] = true;
			});
		}
		this.loadPricePointList()
	}

	sortData(column) {
		this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
		this.sortColumn = column;
		this.page = 1;
		this.loadPricePointList();
	}

	loadPricePointList() {
		this.errorMessage = '';
		this.loading = true;
		this.PricePointService.all((this.page - 1) * this.filter.limit, this.filter.limit, this.sortColumn, this.reverseSort)
			.then(({ total, results }) => {
				this.total = total;
				this.pricePoints = results;
				this.loading = false;
			})
			.catch(err => {
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
				this.loading = false;
			})
	}

	onDateChange() {
		if (this.model.date) {
			this.model.periodApplied = this.moment(this.model.date).startOf('month').format('YYYY-MM-DD');
			this.model.periodAppliedWord = this.moment(this.model.date).startOf('month').format('MMMM YYYY');
		}
	}

	askCreate() {
		this.Modal.confirm({
			header: this.$translate.instant('item.create_another_title'),
			message: this.$translate.instant('item.create_another_message'),
			callback: ({
				modal,
				$scope
			}) => {
				this.reset()
				modal.close()
			},
			negative: ({
				modal,
				$scope
			}) => {
				this.reset()
				modal.close()
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}

	submit() {
		this.loading = true;
		this.errorMessage = null;
		this.model.date = this.moment(this.model.date).startOf('day').format('YYYY-MM-DD');
		this.PricePointService.create(this.model)
			.then((data) => {
				this.loading = false;
				this.askCreate()
			})
			.catch((err) => {
				this.loading = false;
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage = err.data.message || err;
				}
			})
	}

	update() {
		this.loading = true;
		this.errorMessage = null;
		this.model.date = this.moment(this.model.date).startOf('day').format('YYYY-MM-DD');
		this.PricePointService.update(this.rawId, this.model)
			.then((data) => {
				this.loading = false;
				this.reset(true)
				this.loadPricePointList()
			})
			.catch((err) => {
				this.loading = false
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage = err.data.message || err;
				}
			})
	}
	edit(pricePointObj) {
		this.rawId = pricePointObj.id;
		this.defaultModel = pricePointObj;
		this.defaultModel.branchId = this.branchId;
		this.model = angular.copy(this.defaultModel);
	}
	reset(forceClear) {
		if (forceClear) {
			this.rawId = null;
			this.defaultModel = {
				branchId: this.branchId,
				date: '',
				pricePoint: '',
				period: 'MONTHLY',
				periodApplied: '',
				comment: '',
			}
		}
		this.model = angular.copy(this.defaultModel)
		this.loadPricePointList()
	}

	isPastDate(date) {
		return this.moment().isSameOrAfter(moment(date))
	}
}

export default PricePointController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/price_point/price_point.controller.js